import { render, staticRenderFns } from "./WizardButton.vue?vue&type=template&id=4c9fb049&"
import script from "./WizardButton.vue?vue&type=script&lang=js&"
export * from "./WizardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports